import { useStore } from 'effector-react'

import {
  $withdrawalGroups,
  $totalCountOfWithdrawalGroups,
  getWithdrawalGroups,
  withdrawalGroupsListMounted,
} from './model'
import { WithdrawalGroupRequest } from './types'

export const useWithdrawalGroups = () => {
  const onChangeWithdrawalGroupsList = ({
    limit,
    page,
    orderBy,
    orderDirection,
    searchText,
  }: WithdrawalGroupRequest) => {
    withdrawalGroupsListMounted({
      limit,
      page,
      orderBy,
      orderDirection,
      searchText,
    })
  }
  const loading = useStore(getWithdrawalGroups.pending)

  const withdrawalGroups = useStore($withdrawalGroups)
  const totalCountOfWithdrawalGroups = useStore($totalCountOfWithdrawalGroups)
  return {
    withdrawalGroups,
    totalCountOfWithdrawalGroups,
    loading,
    onChangeWithdrawalGroupsList,
  }
}
